export default "__VITE_ASSET__49880147__"